export const IS_CHINA = process.env.GATSBY_CHINA_VERSION === 'true'
